export default "__VITE_ASSET__oEzVggL$__"